export default __webpack_public_path__ + "static/media/87_mobile.d498d5fe.jpg";